import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
export const BannerActions = styled("div")`
    display: inline-flex;
    align-items: center;
    margin: ${sizes.xSmall}px ${sizes.xSmall}px 0 0;
`;
//# sourceMappingURL=BannerActions.js.map